import React, { useState, useEffect } from "react";
import { ActiveComponentEnum as ActiveComponentType } from "enums/enums";
import "bootstrap/dist/css/bootstrap.min.css";
import StaticProgressBar from "components/controls/StaticProgressBar/StaticProgressBar";
import Card from "components/Card/Card";
import Const from "const.json";
import ListItem from "components/controls/ListItem/ListItem";
import { EntityComplaint } from "types/EntityComplaint";
import {
  GetComplaintAboutAuthorities,
  GetLocalAuthoritiesDetails,
  GetLocalAuthorityDropDownList,
} from "api/apiService";
import { useYearFromRedux } from "utils/utilsLogic";
import DropDown from "../controls/DropDown/DropDown";
import { useAppSelector } from '../../redux/hooks';
import useApi from "hooks/useApi";
import WithApi from "components/ui/WithApi/WithApi";
import { Option } from 'types/DropDown';

const LocalAuthoritiesThatHaveComplainedAbout: React.FC = () => {
  const [activeComponent, setActiveComponent] = useState(ActiveComponentType.List);
  const [selectedComplaint, setSelectedComplaint] = useState<EntityComplaint | null>(null);
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);

  const { comparisonTextToLastYear } = useYearFromRedux();
  const { callApi, data, loading, error } = useApi<EntityComplaint[]>(GetComplaintAboutAuthorities);
  const { period } = useAppSelector((state) => state.general);

  useEffect(() => {
    fetchDataForOption();
    setActiveComponent(ActiveComponentType.List);
    setSelectedOption(null);
  }, [period]);

  useEffect(()=>{
    fetchDataForOption(selectedOption?.id);
  },[selectedOption]);

  const fetchDataForOption = (selectedOption?: string) => {
    callApi(selectedOption);
  }

  const handleSelectOption = async (optionId?: string) => {
    const resolvedOptions = await GetLocalAuthorityDropDownList();
    const selected = resolvedOptions.find(option => option.id === optionId);
    setSelectedOption(selected || null);
    fetchDataForOption(optionId);
  };


  const handleNavigation = (
    componentName: ActiveComponentType,
    complaintEntity: EntityComplaint | null = null
  ) => {
    setActiveComponent(componentName);
    setSelectedComplaint(complaintEntity);
  };

  return (
    <div>
      {activeComponent === ActiveComponentType.List && (
        <Card
          header={Const.localAuthoritiesThatHaveComplainedAbout}
          subHeader={`${Const.localitiesLeadInComplaints}\n${comparisonTextToLastYear}`}
          components={[
            <DropDown
              options={GetLocalAuthorityDropDownList}
              title={Const.selectLocalAuthority}
              placeholder={Const.typeNameOfLocalAuthority}
              onSelect={handleSelectOption}
            />,
            <WithApi data={data} loading={loading} error={error}>
              <StaticProgressBar
                progressBarAriaLabel={Const.theLocalAuthoritiesArrangedDescendingOrderOfNumberOfComplaints}
                onNavigate={handleNavigation}
                complaints={data}
              />
            </WithApi>,
          ]}
        />
      )}
      {activeComponent === ActiveComponentType.EntityDetails && selectedComplaint && (
        <Card
          components={[
            <ListItem
              onNavigate={handleNavigation}
              complaint={selectedComplaint}
              fetchDetails={GetLocalAuthoritiesDetails}
              isShowDetails={true}
              isComparedOnYear={true}
            />,
          ]}
        />
      )}
    </div>
  );
};

export default LocalAuthoritiesThatHaveComplainedAbout;
